import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import debounce from 'lodash/debounce'

import useAxios from 'hooks/useAxios'
import { DistributionSetting } from '.'
import { getSurveyTokenFromId } from 'reducers'

const withDebouncedAudienceRules = (Component) =>
  class extends React.Component {
    static propTypes = {
      audienceRules: PropTypes.array,
    }

    state = {
      // eslint-disable-next-line
      delayedAudienceRules: this.props.audienceRules,
    }

    debounceSetState = debounce((...args) => this.setState(...args), 1000)

    componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        this.debounceSetState({
          delayedAudienceRules: this.props.audienceRules,
        })
      }
    }

    render() {
      return <Component {...this.props} delayedAudienceRules={this.state.delayedAudienceRules} />
    }
  }

export class Container extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    matchedCustomers: PropTypes.object,
    getNumbersOfSpreadEmails: PropTypes.func.isRequired,
  }

  render() {
    return (
      <DistributionSetting
        {...this.props}
        numbersOfSpreadEmails={this.props.getNumbersOfSpreadEmails(
          this.props.matchedCustomers.number_of_customer
        )}
        plan={R.path(['subscription', 'plan'])(this.props.user)}
      />
    )
  }
}

const isFetching = ({ loading, data, error }) => loading || (data == null && !error)

const withDistributionData = (Component) =>
  function WithDistributionData(props) {
    const matchedCustomers = useAxios({
      url: `survey/survey/${props.surveyToken}/audience/`,
      method: 'post',
      data: {
        audience_rules: props.delayedAudienceRules,
        show_list: false,
      },
    })
    const user = useAxios({ url: 'account/users/me/v2/' })

    return (
      <Component
        {...props}
        matchedCustomers={{ ...matchedCustomers.data, loading: matchedCustomers.loading }}
        user={{ ...user.data, loading: isFetching(user) }}
      />
    )
  }

export const DistributionSettingContainer = R.compose(
  withRouter,
  connect((state, ownProps) => ({
    surveyToken: getSurveyTokenFromId(state, ownProps.match.params.surveyId),
  })),
  withDebouncedAudienceRules,
  withDistributionData
)(Container)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/DistributionSetting/container.js